import { render, staticRenderFns } from "./SpinnerWheel.vue?vue&type=template&id=5573223a&scoped=true&"
import script from "./SpinnerWheel.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheel.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheel.vue?vue&type=style&index=0&id=5573223a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5573223a",
  null
  
)

export default component.exports